(function () {
  // Only initialize once
  if (window.flBundleComposerInitialized) return;
  window.flBundleComposerInitialized = true;

  class ProductComposer {
    constructor(container, bundleComposer) {
      this.container = container;
      this.bundleComposer = bundleComposer;
      this.productIndex = parseInt(container.dataset.productIndex);
      this.maxSelections = parseInt(container.dataset.maxSelections);
      this.selectedVariants = new Map(); // Map of variantId -> quantity
      this.totalSelected = 0;

      this.init();
    }

    init() {
      // Initialize all variant items
      this.container.querySelectorAll("[data-variant-item]").forEach((item) => {
        const addBtn = item.querySelector(".fl-variant-item__add-btn");
        const quantityPicker = item.querySelector(".quantity-picker");
        const decreaseBtn = item.querySelector("[data-decrease]");
        const increaseBtn = item.querySelector("[data-increase]");
        const quantityInput = item.querySelector(".quantity-input");

        // Add button click
        addBtn.addEventListener("click", () => {
          if (this.totalSelected < this.maxSelections) {
            this.showQuantityPicker(item);
            this.updateQuantity(item, 1);
          }
        });

        // Decrease button
        decreaseBtn.addEventListener("click", () => {
          const currentQty = parseInt(quantityInput.value);
          if (currentQty > 0) {
            this.updateQuantity(item, currentQty - 1);
          }
        });

        // Increase button
        increaseBtn.addEventListener("click", () => {
          const currentQty = parseInt(quantityInput.value);
          if (this.totalSelected < this.maxSelections) {
            this.updateQuantity(item, currentQty + 1);
          }
        });
      });
    }

    showQuantityPicker(item) {
      const addBtnWrapper = item.querySelector(".add-button-wrapper");
      const quantityPicker = item.querySelector(".quantity-picker");

      addBtnWrapper.classList.add("hidden");
      quantityPicker.classList.remove("hidden");

      // Update carousel height after showing picker
      this.bundleComposer.updateCarouselHeight();
    }

    hideQuantityPicker(item) {
      const addBtnWrapper = item.querySelector(".add-button-wrapper");
      const quantityPicker = item.querySelector(".quantity-picker");

      addBtnWrapper.classList.remove("hidden");
      quantityPicker.classList.add("hidden");

      // Update carousel height after hiding picker
      this.bundleComposer.updateCarouselHeight();
    }

    updateQuantity(item, newQuantity) {
      const variantId = item.dataset.variantId;
      const variantTitle = item.dataset.variantTitle;
      const quantityInput = item.querySelector(".quantity-input");
      const currentQty = parseInt(quantityInput.value);

      // Calculate the difference
      const diff = newQuantity - currentQty;

      // Check if we can add more
      if (this.totalSelected + diff > this.maxSelections) {
        return;
      }

      // Update the quantity
      quantityInput.value = newQuantity;

      // Update selected variants map
      if (newQuantity === 0) {
        this.selectedVariants.delete(variantId);
        this.hideQuantityPicker(item);
      } else {
        this.selectedVariants.set(variantId, {
          quantity: newQuantity,
          title: variantTitle,
        });
      }

      // Update total
      this.totalSelected = Array.from(this.selectedVariants.values()).reduce(
        (sum, v) => sum + v.quantity,
        0
      );

      // Update UI
      this.updateUI();

      // Notify bundle composer
      this.bundleComposer.onProductSelectionChanged();
    }

    updateUI() {
      // Update counter
      this.container.querySelector("[data-added-items]").textContent =
        this.totalSelected;

      // Update buttons state
      this.container.querySelectorAll("[data-variant-item]").forEach((item) => {
        const increaseBtn = item.querySelector("[data-increase]");
        const decreaseBtn = item.querySelector("[data-decrease]");
        const quantityInput = item.querySelector(".quantity-input");
        const currentQty = parseInt(quantityInput.value);

        // Disable/enable increase button
        increaseBtn.disabled =
          this.totalSelected >= this.maxSelections && currentQty === 0;

        // Disable/enable decrease button
        decreaseBtn.disabled = currentQty === 0;
      });
    }

    isComplete() {
      return this.totalSelected === this.maxSelections;
    }

    getSelectedVariants() {
      return this.selectedVariants;
    }
  }

  class BundleComposer {
    constructor(container) {
      this.container = container;
      this.bundleId = container.dataset.bundleId;
      this.productComposers = [];
      this.currentStep = 1;
      this.addonSelected = false;

      // Get bundle data
      this.bundleVariantId = container.querySelector(
        ".fl-bundle-composer__data"
      ).dataset.bundleVariantId;
      this.categories = JSON.parse(
        container.querySelector(".fl-bundle-composer__data").dataset.categories
      );
      this.hasSecondProduct =
        container.querySelector(".fl-bundle-composer__data").dataset
          .hasSecondProduct === "true";
      this.hasAnyComposer =
        container.querySelector(".fl-bundle-composer__data").dataset
          .hasAnyComposer === "true";

      // Get other products data
      this.otherProducts = [];
      container
        .querySelectorAll(".fl-bundle-composer__data [data-category-index]")
        .forEach((el) => {
          this.otherProducts.push({
            categoryIndex: parseInt(el.dataset.categoryIndex),
            categoryTitle: el.dataset.categoryTitle,
            productTitle: el.dataset.productTitle,
            defaultVariantId: el.dataset.defaultVariantId,
            productId: parseInt(el.dataset.productId),
            hasComposer: el.dataset.hasComposer === 'true',
            categoryQuantity: parseInt(el.dataset.categoryQuantity) || 1
          });
        });

      // Get navigation elements
      this.track = container.querySelector(".fl-bundle-composer__track");
      this.backBtn = container.querySelector("[data-back-step]");

      // Get add-on elements
      this.addonContainer = container.querySelector("[data-addon-container]");
      this.addonProduct = container.querySelector("[data-addon-product]");

      // Get next indicator
      this.nextIndicator = container.querySelector("[data-next-indicator]");

      this.init();
    }

    init() {
      // Initialize product composers
      this.container
        .querySelectorAll(".fl-product-composer")
        .forEach((composerEl) => {
          const composer = new ProductComposer(composerEl, this);
          this.productComposers.push(composer);
        });

      // Check if we have any composers
      this.hasComposers = this.productComposers.length > 0;

      // Initialize navigation if we have multiple steps
      if (this.hasSecondProduct) {
        this.initNavigation();
      }

      // Initialize add-on product if present
      if (this.addonProduct) {
        this.initAddon();
      }

      // Override the default add to cart behavior
      this.overrideAddToCart();

      // If we have composers, immediately disable the button
      if (this.hasComposers) {
        const buyButton = document.querySelector("buy-buttons button");
        if (buyButton) {
          buyButton.disabled = true;
        }
      }

      // Set initial carousel height
      setTimeout(() => {
        this.updateCarouselHeight(1);
      }, 100);

      // Update height on window resize
      window.addEventListener("resize", () => {
        this.updateCarouselHeight();
      });
    }

    initNavigation() {
      // Back button click
      if (this.backBtn) {
        this.backBtn.addEventListener("click", () => {
          this.goToStep(1);
        });
      }

      // Next indicator click
      if (this.nextIndicator) {
        this.nextIndicator.addEventListener("click", () => {
          const firstComposer = this.productComposers[0];
          if (
            firstComposer &&
            firstComposer.isComplete() &&
            this.currentStep === 1
          ) {
            this.goToStep(2);
          }
        });
      }
    }

    initAddon() {
      // Find the add to cart button in the horizontal product
      const addToCartBtn = this.addonProduct.querySelector(
        'button[type="submit"], button[aria-controls]'
      );

      if (addToCartBtn) {
        // Store original text
        this.addonOriginalText = addToCartBtn.textContent.trim();

        // If it's a quick-buy button, remove the aria-controls to prevent drawer opening
        if (addToCartBtn.hasAttribute("aria-controls")) {
          addToCartBtn.removeAttribute("aria-controls");
        }

        // Override click behavior
        addToCartBtn.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          // Toggle addon selection
          this.addonSelected = !this.addonSelected;

          if (this.addonSelected) {
            addToCartBtn.textContent = "Ajouté";
            this.addonProduct.classList.add("added");
          } else {
            addToCartBtn.textContent = this.addonOriginalText;
            this.addonProduct.classList.remove("added");
          }
        });

        // Prevent form submission if it's a form button
        const form = addToCartBtn.closest("form");
        if (form) {
          form.addEventListener("submit", (e) => {
            e.preventDefault();
          });
        }
      }
    }

    goToStep(step) {
      this.currentStep = step;

      // Update track position
      if (this.track) {
        if (step === 2) {
          this.track.classList.add("step-2");
        } else {
          this.track.classList.remove("step-2");
        }
      }

      // Update step indicators
      this.container
        .querySelectorAll(".fl-bundle-composer__step")
        .forEach((stepEl) => {
          const stepNum = parseInt(stepEl.dataset.step);
          if (stepNum === step) {
            stepEl.classList.add("active");
          } else {
            stepEl.classList.remove("active");
          }
        });

      // Update carousel height
      this.updateCarouselHeight(step);

      // Focus management for accessibility
      setTimeout(() => {
        const composer = this.container.querySelector(
          `.fl-product-composer[data-product-index="${step}"]`
        );
        if (composer) {
          const firstButton = composer.querySelector(
            ".fl-variant-item__add-btn, .quantity-btn:not(:disabled)"
          );
          if (firstButton) {
            firstButton.focus();
          }
        }
      }, 450); // After animation completes
    }

    updateCarouselHeight(step = this.currentStep) {
      const carousel = this.container.querySelector(
        ".fl-bundle-composer__carousel"
      );
      if (!carousel) return;

      // Small delay to ensure DOM is ready
      setTimeout(() => {
        const activeComposer = this.container.querySelector(
          `.fl-product-composer[data-product-index="${step}"]`
        );

        if (activeComposer) {
          // Get the scrollHeight which includes all content
          const composerHeight = activeComposer.scrollHeight;

          // Set the carousel height
          carousel.style.height = `${composerHeight}px`;
        }
      }, 50);
    }

    onProductSelectionChanged() {
      // Update next indicator state
      if (this.hasSecondProduct && this.nextIndicator) {
        const firstComposer = this.productComposers[0];
        if (firstComposer && firstComposer.productIndex === 1) {
          if (firstComposer.isComplete()) {
            this.nextIndicator.classList.add("active");
          } else {
            this.nextIndicator.classList.remove("active");
          }
        }
      }

      // Auto-advance to step 2 when step 1 is complete
      if (this.hasSecondProduct) {
        const firstComposer = this.productComposers[0];
        if (
          firstComposer &&
          firstComposer.productIndex === 1 &&
          firstComposer.isComplete() &&
          this.currentStep === 1
        ) {
          setTimeout(() => {
            this.goToStep(2);
          }, 300); // Small delay for better UX
        }
      }

      // Update the main add to cart button based on all products' completion status
      this.updateAddToCartButton();
    }

    areAllProductsComplete() {
      // If no composers, always return true
      if (!this.hasComposers) {
        return true;
      }

      return this.productComposers.every((composer) => composer.isComplete());
    }

    updateAddToCartButton() {
      const buyButton = document.querySelector("buy-buttons button");
      if (buyButton) {
        // Store original text if not already stored
        if (!buyButton.dataset.originalText) {
          buyButton.dataset.originalText = buyButton.textContent;
        }

        if (this.areAllProductsComplete()) {
          buyButton.disabled = false;
          buyButton.classList.remove("fl-bundle-incomplete");
          buyButton.textContent =
            buyButton.dataset.originalText || "Ajouter au panier";
        } else {
          // Calculate remaining selections for each product
          let message = "";

          if (this.hasSecondProduct) {
            const firstComposer = this.productComposers[0];
            const secondComposer = this.productComposers[1];

            if (firstComposer && !firstComposer.isComplete()) {
              const remaining =
                firstComposer.maxSelections - firstComposer.totalSelected;
              message = `Étape 1: Sélectionnez ${remaining} saveur(s)`;
            } else if (secondComposer && !secondComposer.isComplete()) {
              const remaining =
                secondComposer.maxSelections - secondComposer.totalSelected;
              message = `Étape 2: Sélectionnez ${remaining} saveur(s)`;
            }
          } else {
            // Single product
            const composer = this.productComposers[0];
            if (composer) {
              const remaining = composer.maxSelections - composer.totalSelected;
              message = `Sélectionnez ${remaining} saveur(s)`;
            }
          }

          buyButton.disabled = true;
          buyButton.classList.add("fl-bundle-incomplete");
          buyButton.textContent = message;
        }
      }
    }

    overrideAddToCart() {
      // Wait a bit for buy-buttons component to initialize
      setTimeout(() => {
        const buyButton = document.querySelector("buy-buttons button");
        if (!buyButton) return;

        // Store original text and handler
        buyButton.dataset.originalText = buyButton.textContent;

        // Initial button state
        this.updateAddToCartButton();

        // Clone button to remove all existing event listeners
        const newButton = buyButton.cloneNode(true);
        buyButton.parentNode.replaceChild(newButton, buyButton);

        // Add our custom handler
        newButton.addEventListener("click", async (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          // Check if all products are complete
          if (!this.areAllProductsComplete()) {
            return;
          }

          // Build the bundle items array
          const bundleItems = [];

          // Add selected variants from all product composers
          this.productComposers.forEach((composer, composerIndex) => {
            // Get category title - use the first category for product 1, second for product 2 if exists
            const categoryTitle = this.categories[composerIndex]
              ? this.categories[composerIndex].title
              : `Product ${composerIndex + 1}`;

            composer.getSelectedVariants().forEach((data, variantId) => {
              bundleItems.push({
                variantId: parseInt(variantId),
                quantity: data.quantity,
                category: categoryTitle,
                type: "product",
                properties: {},
              });
            });
          });

          // Add other products from remaining categories (skip categories used by composers)
          const skipCategoryCount = this.productComposers.length;
          this.otherProducts.forEach((product) => {
            // Only add if the category index is beyond what we're using for composers
            if (product.categoryIndex >= skipCategoryCount) {
              bundleItems.push({
                variantId: parseInt(product.defaultVariantId),
                quantity: product.categoryQuantity || 1,
                category: product.categoryTitle,
                type: "product",
                properties: {},
              });
            }
          });

          // Add addon product if selected
          if (this.addonSelected && this.addonProduct) {
            const addonVariantId = this.addonProduct.dataset.addonVariantId;
            if (addonVariantId) {
              bundleItems.push({
                variantId: parseInt(addonVariantId),
                quantity: 1,
                type: "addOns",
                properties: {},
              });
            }
          }

          // Create the identifier
          const currentDate = Date.now();
          const identifier = `${this.bundleId}_${currentDate}`;

          // Build line item properties for display
          const displayProperties = {};
          const usedKeys = new Set();

          // Add selected variants to display properties
          this.productComposers.forEach((composer) => {
            composer.getSelectedVariants().forEach((data, variantId) => {
              if (data.quantity > 0) {
                // Create a unique key for this variant
                let key = data.title;
                let keyIndex = 1;
                while (usedKeys.has(key)) {
                  key = `${data.title} (${keyIndex})`;
                  keyIndex++;
                }
                usedKeys.add(key);
                displayProperties[key] = `x${data.quantity}`;
              }
            });
          });

          // Add silent products (without composers) to display properties
          this.otherProducts.forEach((product) => {
            if (!product.hasComposer || !this.hasComposers) {
              // Use the actual product title
              const productTitle = product.productTitle || product.categoryTitle || `Product ${product.productId}`;
              const quantity = product.categoryQuantity || 1;
              
              if (quantity > 0) {
                let key = productTitle;
                let keyIndex = 1;
                while (usedKeys.has(key)) {
                  key = `${productTitle} (${keyIndex})`;
                  keyIndex++;
                }
                usedKeys.add(key);
                displayProperties[key] = `x${quantity}`;
              }
            }
          });

          // Add addon to display properties if selected
          if (this.addonSelected && this.addonProduct) {
            // Since output_link is false, the title is in span.text-sm.bold
            const titleElement = this.addonProduct.querySelector(
              ".horizontal-product__info span.text-sm.bold"
            );
            const addonTitle = titleElement?.textContent?.trim() || "Add-on";
            displayProperties[addonTitle] = "x1";
          }

          // Build the add to cart data
          const addToCartData = {
            items: [
              {
                id: this.bundleVariantId,
                quantity: 1,
                properties: {
                  "__foxsell:dynamic_add_on_bundle_id": identifier,
                  "__foxsell:dynamic_add_on_bundle_items":
                    JSON.stringify(bundleItems),
                  ...displayProperties,
                },
              },
            ],
          };

          // Submit to cart
          try {
            const response = await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(addToCartData),
            });

            const responseText = await response.text();

            if (response.ok) {
              try {
                const data = JSON.parse(responseText);

                // Trigger cart update events
                document.dispatchEvent(new CustomEvent("cart:item-added"));

                document.documentElement.dispatchEvent(
                  new CustomEvent("cart:refresh", {
                    bubbles: true,
                    detail: {
                      baseEvent: "variant:add",
                      cart: data,
                    },
                  })
                );

                document.querySelector(".cart-drawer")?.show();
              } catch (parseError) {
                console.error("Error parsing success response:", parseError);
              }
            } else {
              console.error("Cart API error:", response.status, responseText);

              // Try to parse error response
              try {
                const error = JSON.parse(responseText);
                console.error("Error details:", error);

                // Show error message
                const errorMessage = document.querySelector(
                  "[data-error-message]"
                );
                if (errorMessage) {
                  errorMessage.textContent =
                    error.description ||
                    error.message ||
                    "Une erreur est survenue";
                  errorMessage.classList.remove("hidden");
                }
              } catch (parseError) {
                console.error("Could not parse error response:", responseText);
                alert("Une erreur est survenue lors de l'ajout au panier");
              }
            }
          } catch (error) {
            console.error("Error adding bundle to cart:", error);
            alert("Une erreur est survenue lors de l'ajout au panier");
          }
        });
      }, 100); // Small delay to ensure buy-buttons component is initialized
    }
  }

  // Initialize all bundle composers on the page
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".fl-bundle-composer").forEach((container) => {
      new BundleComposer(container);
    });
  });

  // Re-initialize on section reload (for theme editor)
  document.addEventListener("shopify:section:load", () => {
    document.querySelectorAll(".fl-bundle-composer").forEach((container) => {
      if (!container.dataset.initialized) {
        new BundleComposer(container);
        container.dataset.initialized = "true";
      }
    });
  });
})();
